export const SIMPLEUI_EVENT_MAP = {
  LOADING_SPINNER: {
    MFE_INIT: 'MfeInit',
    INITIAL: 'Initial',
    POST_SIGN_IN_OR_CREATE_ACCOUNT: 'PostSignInOrCreateAccount',
    PRE_CUSTOM_ERROR: 'PreCustomError',
    PRE_TENANT_SELECTOR: 'PreTenantSelector'
  }
};

export const AUTH_MODE = {
  STRATUS: 'Stratus',
  ONE_CLOUD: 'OneCloud'
};
